export const LOADING_INC = 'LOADING_INC'
export const LOADING_DEC = 'LOADING_DEC'